import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableSelect, SearchableSelectProps } from 'record-it-components/input/SearchableSelect/SearchableSelect';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { TimeTrackingActivityCompilationUtils } from '../../../classes/entities/TimeTrackingActivityCompilation/TimeTrackingActivityCompilationUtils';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { SelectEntityItem, useSelectEntityItems } from '../../../hooks/entity/useSelectEntityItems/useSelectEntityItems';
import { UseSelectEntityItemsUtils } from '../../../hooks/entity/useSelectEntityItems/UseSelectEntityItemsUtils';
export type TimeTrackingActivityCompilationSelectProps = PropsWithoutChildren<Omit<SearchableSelectProps<unknown>, 'getKeyOfItem' | 'getDisplayTextOfItem' | 'items' | 'value' | 'onValueChanged' | 'label'>> & {
  value: string;
  onValueChanged: (value: string) => void;
  userGroupId: string;
  label?: string;
};
export const TimeTrackingActivityCompilationSelect: FunctionComponent<TimeTrackingActivityCompilationSelectProps> = React.memo(props => {
  const $ = _c(24);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onValueChanged;
  let remainingProps;
  let userGroupId;
  let value;
  if ($[2] !== t0) {
    ({
      value,
      onValueChanged,
      userGroupId,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onValueChanged;
    $[4] = remainingProps;
    $[5] = userGroupId;
    $[6] = value;
  } else {
    onValueChanged = $[3];
    remainingProps = $[4];
    userGroupId = $[5];
    value = $[6];
  }
  const {
    t
  } = useTranslation();
  const compilations = useEntities(EntityName.TimeTrackingActivityCompilation, "getByUserGroupId", userGroupId);
  let t1;
  if ($[7] !== t) {
    t1 = t("components.timeTrackingActivityCompilation.TimeTrackingActivityCompilationSelect.unknownItem");
    $[7] = t;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== compilations || $[10] !== onValueChanged || $[11] !== t1 || $[12] !== value) {
    t2 = {
      value,
      entities: compilations,
      entityNotFoundText: t1,
      onValueChanged,
      getDisplayTextOfEntity: TimeTrackingActivityCompilationUtils.displayTextGetter,
      getKeyOfEntity: TimeTrackingActivityCompilationUtils.keyGetter,
      getValueOfEntity: UseSelectEntityItemsUtils.entityIdGetter
    };
    $[9] = compilations;
    $[10] = onValueChanged;
    $[11] = t1;
    $[12] = value;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const useSelectEntityItemsReturnValue = useSelectEntityItems(t2);
  const t3 = useSelectEntityItemsReturnValue.selectedItem;
  const t4 = useSelectEntityItemsReturnValue.items;
  let t5;
  if ($[14] !== t) {
    t5 = t("components.timeTrackingActivityCompilation.TimeTrackingActivityCompilationSelect.label");
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== remainingProps || $[17] !== t5 || $[18] !== useSelectEntityItemsReturnValue.getDisplayTextOfItem || $[19] !== useSelectEntityItemsReturnValue.getKeyOfItem || $[20] !== useSelectEntityItemsReturnValue.items || $[21] !== useSelectEntityItemsReturnValue.onSelectedItemChanged || $[22] !== useSelectEntityItemsReturnValue.selectedItem) {
    t6 = <SearchableSelect value={t3} items={t4} label={t5} onValueChanged={useSelectEntityItemsReturnValue.onSelectedItemChanged} getDisplayTextOfItem={useSelectEntityItemsReturnValue.getDisplayTextOfItem} getKeyOfItem={useSelectEntityItemsReturnValue.getKeyOfItem} data-testid="TimeTrackingActivityCompilationSelect.SearchableSelect" {...remainingProps} />;
    $[16] = remainingProps;
    $[17] = t5;
    $[18] = useSelectEntityItemsReturnValue.getDisplayTextOfItem;
    $[19] = useSelectEntityItemsReturnValue.getKeyOfItem;
    $[20] = useSelectEntityItemsReturnValue.items;
    $[21] = useSelectEntityItemsReturnValue.onSelectedItemChanged;
    $[22] = useSelectEntityItemsReturnValue.selectedItem;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
});